import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__col footer__col--brand">
          <Link to="/" className="footer__brand">
            Agro<em>Nexus</em>
          </Link>
          <p className="footer__tag">
            Import and export of all agro products. Rooted in Kutch,
            Gujarat — delivering premium Indian spices, seeds, and agro
            commodities to buyers across the world.
          </p>
          <div className="footer__social">
            <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noreferrer">
              <FaLinkedinIn />
            </a>
            <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://wa.me/919909729560" aria-label="WhatsApp" target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Explore</h4>
          <ul className="footer__list">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/certifications">Certifications</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Our Range</h4>
          <ul className="footer__list">
            <li><Link to="/products">Cumin Seeds</Link></li>
            <li><Link to="/products">Fennel Seeds</Link></li>
            <li><Link to="/products">Coriander Seeds</Link></li>
            <li><Link to="/products">Black Sesame</Link></li>
            <li><Link to="/products">White Sesame</Link></li>
            <li><Link to="/products">Red Chilly</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Reach Us</h4>
          <ul className="footer__list footer__list--contact">
            <li>
              <FiMapPin />
              <span>
                Near Thakkar Petroleum, Mothla,
                <br />
                Naliya–Bhuj Road, Kutch, Gujarat — 370650
              </span>
            </li>
            <li>
              <FiMail />
              <a href="mailto:info@agronexus.in">info@agronexustrading.in</a>
            </li>
            <li>
              <FiPhone />
              <a href="tel:+919909729560">+91 99097 29560</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bar">
        <div className="container footer__bar-inner">
          <span>© {new Date().getFullYear()} Agronexus Trading Pvt. Ltd. All rights reserved.</span>
          <span className="footer__meta">
            Crafted with care · From field to freight
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
